import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Wand2 } from 'lucide-react';
import { TYPE_OPTIONS } from './constants';

export function BulkLabelDialog({
  open, onOpenChange, unlabeledCats,
  bulkAssignments, setBulkAssignments, onSetAllForType,
  bulkSaving, onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-hidden flex flex-col" data-testid="bulk-label-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Wand2 className="h-4 w-4 text-amber-600" />
            Bulk Label Unlabeled Categories
          </DialogTitle>
          <DialogDescription>
            Tag each category as Income, Expense, or Excluded in one pass. Leave as &ldquo;None&rdquo; to skip.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 pb-2 border-b border-border/40">
          <span className="text-[11px] text-muted-foreground">Set all to:</span>
          <Button size="sm" variant="outline" className="h-7 text-[11px] border-emerald-300 text-emerald-700 hover:bg-emerald-50" onClick={() => onSetAllForType('income')} data-testid="set-all-income-btn">Income</Button>
          <Button size="sm" variant="outline" className="h-7 text-[11px] border-red-300 text-red-700 hover:bg-red-50" onClick={() => onSetAllForType('expense')} data-testid="set-all-expense-btn">Expense</Button>
          <Button size="sm" variant="outline" className="h-7 text-[11px] border-slate-300 text-slate-600 hover:bg-slate-50" onClick={() => onSetAllForType('exclude')} data-testid="set-all-exclude-btn">Excluded</Button>
          <Button size="sm" variant="ghost" className="h-7 text-[11px]" onClick={() => onSetAllForType('none')} data-testid="set-all-none-btn">None</Button>
        </div>
        <div className="flex-1 overflow-y-auto -mx-6 px-6 py-2 space-y-1">
          {unlabeledCats.length === 0 ? (
            <div className="py-8 text-center text-sm text-muted-foreground">No unlabeled categories.</div>
          ) : unlabeledCats.map(cat => (
            <div key={cat.id} className="flex items-center gap-2 px-2 py-1.5 rounded border border-border/40 bg-white" data-testid="bulk-label-row">
              <span className="flex-1 text-sm font-medium truncate">{cat.name}</span>
              <span className="text-[10px] text-muted-foreground">{(cat.subcategories || []).length} sub</span>
              <Select
                value={bulkAssignments[cat.id] || 'none'}
                onValueChange={v => setBulkAssignments(a => ({ ...a, [cat.id]: v }))}
              >
                <SelectTrigger className="h-7 w-32 text-xs" data-testid="bulk-label-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {TYPE_OPTIONS.map(opt => <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={bulkSaving || unlabeledCats.length === 0} data-testid="bulk-label-save-btn">
            {bulkSaving ? 'Saving…' : 'Apply Labels'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
